import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { PercentButton } from '../../../../components/shared/icons';
import { EntityType } from '../../../../components/shared/constants';
import { CustomerCommissionPopup } from "../popups/CustomerCommissionPopup";
import useBoolean from "../../../../hooks/useBoolean";

const EditComissionsColumn = ({
    row,
    column: {
        rateId,
        refreshRateAssignments,
    }
}) => {
    const {
        value: isEditComissionsModalOpen,
        setTrue: openEditComissionsModal,
        setFalse: closeEditComissionsModal
    } = useBoolean(false);

    const customerDerivedName = useMemo(() => {
        if (row.EntityTypeId == EntityType.Customer && row.EntityId) {
          return row.CustomerName ?? '';
        }
    
        return ''
      }, [row.CustomerName, row.EntityId, row.EntityTypeId]);

    return (
        <>
            <PercentButton
                content={'EditCommissions'}
                onClick={openEditComissionsModal}
                style={{ color: row.RateCustomerCommissions?.length ? 'red' : undefined }}
            />
            {isEditComissionsModalOpen && (
            <CustomerCommissionPopup
                custom
                key={row?.Id}
                isOpen={isEditComissionsModalOpen}
                rateId={rateId}
                rateAssignment={row}
                customerName={customerDerivedName}
                onClose={closeEditComissionsModal}
                refreshRateAssignments={refreshRateAssignments}
            />
            )}
      </>
    );
};

EditComissionsColumn.propTypes = {
    row: PropTypes.shape({
        Id: PropTypes.number.isRequired,
        CustomerName: PropTypes.string,
        EntityTypeId: PropTypes.number.isRequired,
        EntityId: PropTypes.number,
        RateCustomerCommissions: PropTypes.array,
    }).isRequired,
    column: PropTypes.shape({
        rateId: PropTypes.number.isRequired,
        refreshRateAssignments: PropTypes.func,
    }).isRequired,
};

EditComissionsColumn.defaultProps = {
    refreshRateAssignments: () => {},
    column: {
        refreshRateAssignments: () => {},
    },
};

export default EditComissionsColumn;
